import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 라우트 이동 시 스크롤을 최상단으로 되돌린다.
 *
 * BrowserRouter는 페이지 전환 시 스크롤 위치를 초기화하지 않는다. 그래서 footer(하단)에서
 * 약관 링크를 누르면 새 문서도 같은 스크롤 오프셋에서 열려 본문 중간부터 보이게 된다.
 *
 * 해시(#anchor)가 있는 이동은 해당 요소로 가야 하므로 초기화하지 않는다.
 * BrowserRouter 내부에 렌더해야 useLocation을 쓸 수 있다.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
